// import information_json from "@public/assets_default/data/information.json"
//TEST用↑

function getApiUrl() {
  // 本番やステージング環境では、現在のホスト名に基づいてAPIのURLを動的に構築
  const domainMapping = {
    'www.minna-no-ginko.com': 'https://corporate.minna-no-ginko.com',
    'stg-www.minna-no-ginko.com': 'https://stg-corporate.minna-no-ginko.com',
    'www.minna-no-ginko.local': 'https://corporate.minna-no-ginko.local',
    'stg-www.minna-no-ginko.local': 'https://stg-corporate.minna-no-ginko.local',
  };
  const targetDomain = domainMapping[window.location.hostname] || 'https://corporate.minna-no-ginko.com'; // デフォルトは本番
  return `${targetDomain}/common/data/information.json`;
}

export function createNewsState(filterCondition) {
  const url = getApiUrl();
  console.log(`Fetching from: ${url}`);

  let newsList = $state([]);
  let isLoading = $state(true);
  let error = $state(null);
  $effect(() => {
    const fetchNews = async () => {
      isLoading = true; // フェッチ開始時にローディング状態をtrueに
      error = null; // エラーをリセット
      try {
        const response = await fetch(url);
        if(!response.ok) throw new Error('corporate-news.jsonデータの取得に失敗しました');
        const data = await response.json();
        let allNews = data.information;

        //TEST用↓
        // let allNews = information_json.information;

        newsList = allNews.filter(filterCondition).sort((a, b) => new Date(b.date) - new Date(a.date));
      } catch (error) {
        error = 'お知らせの取得に失敗しました。';
        console.error(error);
      } finally {
        isLoading = false; // フェッチ完了時にローディング状態をfalseに
      }
    };
    fetchNews();
  });

  return {
    get newsList() { return newsList; },
    get isLoading() { return isLoading; },
    get error() { return error; },
  };
}